import { Button, Modal } from 'antd';
import React from 'react';
import Reports from '../Plot/Reports';
import { Link } from 'react-router-dom';
import styles from '../Style/ResultPanel.module.scss';
import { IPreprocessedAnalyticsPayload } from '../../../../types/chart';
import { IReport } from '../../../../types/api';
import { IMarker } from '../../../../types/marker';

export function DatasetOfflineModal(props: {
  datasetIsOfflineWarningVisible: boolean;
  text?: string;
  handleCloseDatasetIsOfflineWarning: (status: boolean) => void;
}) {
  return (
    <Modal
      open={props.datasetIsOfflineWarningVisible}
      onCancel={() => props.handleCloseDatasetIsOfflineWarning(false)}
      footer={[
        <Button
          key='ok'
          onClick={() => props.handleCloseDatasetIsOfflineWarning(false)}
        >
          Close
        </Button>,
      ]}
      zIndex={100000}
    >
      <div className={styles.modal}>
        {props.text && props.text}
        {!props.text && (
          <>
            <div>This dataset is not available online.</div>
            {'Please '}
            <Link to={'/contact'}> {'contact us'}</Link>
            {' for more information or data requests.'}
            <div></div>
          </>
        )}
      </div>
    </Modal>
  );
}

export function DatasetHasNoReportModal(props: {
  isVisible: boolean;
  handleClose: (status: boolean) => void;
}) {
  return (
    <Modal
      open={props.isVisible}
      onCancel={() => props.handleClose(false)}
      footer={[
        <Button key='ok' onClick={() => props.handleClose(false)}>
          Close
        </Button>,
      ]}
    >
      <div className={styles.modal}>
        <div>No reports available for this dataset.</div>
        {'Please '}
        <Link to={'/contact'}> {'contact us'}</Link>
        {' for more information.'}
        <div></div>
      </div>
    </Modal>
  );
}

export function DatasetHasNoAnalyticsModal(props: {
  isVisible: boolean;
  handleClose: (status: boolean) => void;
}) {
  return (
    <Modal
      open={props.isVisible}
      onCancel={() => props.handleClose(false)}
      footer={[
        <Button key='ok' onClick={() => props.handleClose(false)}>
          Close
        </Button>,
      ]}
    >
      <div className={styles.modal}>
        <div>This dataset is not available for Analytics</div>
      </div>
    </Modal>
  );
}

export const ReportsModal = (props: {
  isReportsVisible: boolean;
  setIsReportsVisible: (item: boolean) => void;
  links: IReport[];
  updating: boolean;
  error: string;
  category: string;
  onUpdatePreprocessedDataLink: (
    payload: IPreprocessedAnalyticsPayload
  ) => void;
  activePoint?: IMarker | null;
  waterDepth: string;
}) => {
  const {
    isReportsVisible,
    setIsReportsVisible,
    links,
    updating,
    error,
    onUpdatePreprocessedDataLink,
    activePoint,
    category,
    waterDepth,
  } = props;

  const previewDatasetId =
    activePoint?.downloadPage?.find((item) => item.radioKey === category)
      ?.datasetId ?? '';

  return (
    <Modal
      open={isReportsVisible}
      footer={[
        <Button key='close' onClick={() => setIsReportsVisible(false)}>
          Close
        </Button>,
      ]}
      onCancel={() => setIsReportsVisible(false)}
    >
      <Reports
        waterDepth={waterDepth}
        links={links}
        updating={updating}
        error={error}
        onUpdate={onUpdatePreprocessedDataLink}
        coordinates={activePoint?.coordinates!}
        previewDatasetId={previewDatasetId}
      />
    </Modal>
  );
};
